import BasePage from '@components/Layouts/BasePage'
import OrgManagementNavigation from '@components/Navigation/OrgManagementNavigation'
import { ManageSelectedOrgProvider } from '@features/organisations/contexts/ManageSelectedOrg'
import { PermissionsCheckerProvider } from '@lib/permissions'
import {
  createFileRoute,
  Outlet,
  useLocation,
  useParams,
  useRouterState,
} from '@tanstack/react-router'

const OrgSettingsRoute = () => {
  const { orgId } = useParams({ from: '/_auth/orgs/$orgId' })
  const matches = useRouterState({ select: (s) => s.matches })

  const location = useLocation()
  const matchWithTitle = [...matches].reverse().find((d) => d.context.getTitle)
  const title = matchWithTitle?.context.getTitle() || 'Cloudmix'

  const breadcrumbs = matches
    .filter((match) => match.loaderData?.crumb)
    .map(({ pathname, loaderData }) => ({
      title: loaderData?.crumb,
      path: pathname,
      isCurrentPage: pathname === location.pathname,
    }))

  return (
    <ManageSelectedOrgProvider>
      <PermissionsCheckerProvider>
        <BasePage
          title={title}
          navigation={<OrgManagementNavigation orgId={orgId} />}
          breadcrumbs={breadcrumbs}
        >
          <Outlet />
        </BasePage>
      </PermissionsCheckerProvider>
    </ManageSelectedOrgProvider>
  )
}

export const Route = createFileRoute('/_auth/orgs/$orgId')({
  component: OrgSettingsRoute,
  loader: ({ context, params }) => {
    context.setOrg(params.orgId)
  },
})
